<template>
		<div style="background-color:#F5F5F5;width:100%;height:100%;">
			<!-- 主文 -->
			<div style="display:flex;justify-content: center;">
			<div style="background-color:#F5F5F5;display:flex;margin-top:10px;">
				<!-- 2 -->
				<div style="background-color: #FFFFFF;margin-left:14px;width:600px;position:relative;">
					<!-- 2.1 -->
					<div style="margin:10px 10px 0 10px">
						<div style="display: flex;justify-content: space-between;">
							<a v-if="tpas.src!=''" :href="tpas.src" target="_blank">
								<img :src="urls+tpas.url" style="width:273px;height:172px;"></img>
							</a>
							<a v-else>
								<img :src="urls+tpas.url" style="width:273px;height:172px;cursor:pointer;"></img>
							</a>
							<div style="width: 100%;display:flex;flex-wrap: wrap;">
								<div v-for="(item,index) in tpb" :key="index">
									<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width: 142px;height:54px;margin-left:8px;"/></a>
									<a v-else><img :src="urls+item.url" style="width: 142px;height:54px;margin-left:8px;cursor:pointer;"/></a>
								</div>
							</div>
						</div>
					</div>
					<!-- 2.2 -->
					<div >
						<div style="display:flex;border-bottom:#EEEEEE 1px solid;margin:20px 10px;">
							<div class="font" v-for="(item,index) in zx" :key="index"  @click="changes(index)">
								<div :class="(index==0?'bjmagins':'bjmagin')" class="zxfont" :style="index!=tabIndexs?'color:#C5C5C5;':'border-bottom:3px solid;border-image:linear-gradient(to right,#5AD6CE,#38A5EC) 5 5;'">{{item.name}}</div>
							</div>
						</div>
						<!-- 分界线 -->
						<!-- <div class="hove"></div> -->
						<div class="bjtop" style="display:flex;margin-left:10px;">
							<div>
								<div  v-for="(item,index) in tpc" :key="index" >
									<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width:128px;height: 59px;"></img></a>
									<a v-else><img :src="urls+item.url" style="width:128px;height: 59px;cursor:pointer;"></img></a>
								</div>
							</div>
							<div>
								<div  v-for="(item,index) in titlea" :key="index" style="margin-left:27px;">
									<div style="display: flex;margin-top:10px;align-items: center;">
										<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
										<div class="fontcolors" style="margin-left:8px;text-align:left;width:60%;" @click="wztza(item.id)">{{item.title}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 图片1 -->
					<el-carousel height="85px" indicator-position="none">
					  <el-carousel-item v-for="(item,index) in bannerthree" :key="index">
					   <a v-if="item.src!=''" :href="item.src"  target="_blank">
					   	<img :src="urls+item.url" style="width:100%;height:85px;margin-top:10px;"></img>
					   </a>
					   <a v-else>
					   	<img :src="urls+item.url" style="width:100%;height:85px;margin-top:10px;cursor:pointer;"></img>
					   </a>
					  </el-carousel-item>
					</el-carousel>
					<div  style="display:flex;margin-left:10px;margin-top:10px;">
						<div>
							<div  v-for="(item,index) in tpe" :key="index">
								<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width:128px;height: 59px;"></img></a>
								<a v-else><img :src="urls+item.url" style="width:128px;height: 59px;cursor:pointer;"></img></a>
							</div>
						</div>
						<div>
							<div  v-for="(item,index) in titleb" :key="index" style="margin-left:27px;">
								<div style="display: flex;margin-top:10px;align-items:center;">
									<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
									<div class="fontcolors" style="margin-left:8px;text-align:left;width:60%;" @click="wztzb(item.id)">{{item.title}}</div>
								</div>
							</div>
						</div>
					</div>
						<!-- 图片2 -->
						<div class="block" style="margin-top:10px;">
							 <el-carousel height="90px" indicator-position="none">
							   <el-carousel-item v-for="(item,index) in bannerfour" :key="index">
								<a v-if="item.src!=''" :href="item.src"  target="_blank">
									<img :src="urls+item.url" style="height:100%;width:100%;"></img>
								</a>
								<a v-else>
									<img :src="urls+item.url" style="height:100%;width:100%;cursor:pointer;"></img>
								</a>
							   </el-carousel-item>
							 </el-carousel>
						 </div>
					<div  style="display:flex;margin-left:10px;padding-bottom:57px;margin-top:10px;">
						<div>
							<div  v-for="(item,index) in tpg" :key="index">
								<a v-if="item.src!=''" :href="item.src" target="_blank"><img :src="urls+item.url" style="width:128px;height: 59px;"></img></a>
								<a v-else><img :src="urls+item.url" style="width:128px;height: 59px;cursor:pointer;"></img></a>
							</div>
						</div>
						<div>
							<div  v-for="(item,index) in titlec" :key="index" style="margin-left:27px;">
								<div style="display: flex;margin-top:10px;align-items: center;">
									<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
									<div class="fontcolors" style="margin-left:8px;text-align:left;width:60%;" @click="wztzc(item.id)">{{item.title}}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="position:absolute;bottom:10px;right:10px;">
						<el-pagination
						  background
						  layout="prev, pager, next"
						  :total="totals" 
						  :current-page="currentpage"
						  :page-size="pagesize"
						@current-change="handleCurrentChange"
						  >
						</el-pagination>
					</div>	
				</div>
				<!-- 3 -->
				<div style="background-color: #FFFFFF;margin-left:14px;width:324px;padding-left:15px;padding-top:10px;">
					<div style="display: flex;">
						<div class="nvbc flexjust flex flexali" style="flex-direction: column;" @click="zxhy">
							<div><img src="../assets/banner/ren.png" /></div>
							<div class="font colorwhite" >最新会议</div>
						</div>
						<!-- <div class="nvbc" style="margin-left:15px;">
							<a :href="url.curriculum " target="_blank">
							<div class="nvbc flexjust flex flexali" style="flex-direction: column;">
								<div><img src="../assets/banner/shu.png" /></div>
								<div class="font colorwhite"  >最新课程</div>
							</div>
							</a>
						</div> -->
						<div class="nvbc" style="margin-left:15px;">
							<div v-if="url.curriculum!=''">
								<a :href="url.curriculum" target="_blank">
								<div class="nvbc flexjust flex flexali" style="flex-direction: column;">
									<div><img src="../assets/banner/shu.png" /></div>
									<div class="font colorwhite" >最新课程</div>
								</div>
								</a>
							</div>
							
							<div v-else>
								<div class="nvbc flexjust flex flexali" style="flex-direction: column;"  @click="tzd()">
									<div><img src="../assets/banner/shu.png" /></div>
									<div class="font colorwhite" >最新课程</div>
								</div>
							</div>
						</div>
						<div class="nvbc" style="margin-left:15px;">
							<div v-if="url.books!=''">
								<a :href="url.books" target="_blank">
								<div class="nvbc flexjust flex flexali" style="flex-direction: column;">
									<div><img src="../assets/banner/baogao.png" /></div>
									<div class="font colorwhite" >图书报告</div>
								</div>
								</a>
							</div>
							
							<div v-else>
								<div class="nvbc flexjust flex flexali" style="flex-direction: column;"  @click="tze()">
									<div><img src="../assets/banner/baogao.png" /></div>
									<div class="font colorwhite" >图书报告</div>
								</div>
							</div>
						</div>
					</div>
					<div class="font" style="margin:28px 0px 12px;text-align:left;font-weight:600;">其他</div>
						<div class="font nmb" @click="tza()">
							<!-- <div class="ggnm flex flexjust flexali " style="background-color:#425987;justify-content: space-between;margin-top:5px;">
								<div class="flex" style="flex-direction: column;margin-left:20px;color:white;">
									<div style="font-size:16px;">最新培训</div>
									<div class="colortm">LATEST TRAINING</div>
								</div>
								<i class="el-icon-caret-right" style="margin-right:10px;opacity:0.4;"></i>
							</div> -->
							<div class="ggnm" style="margin-top:5px;">
								<img src="../assets/1.png" class="ggnm" />
							</div>
						</div>
						<div class="font nmb" @click="tzb()">
							<!-- <div class="ggnm flex flexjust flexali activeb " style="justify-content: space-between;margin-top:5px;">
								<div class="flex" style="flex-direction: column;margin-left:20px;color:white;">
									<div style="font-size:16px;">线上活动</div>
									<div class="colortm">ONLINE ACTIVITIES</div>
								</div>
								<i class="el-icon-caret-right" style="margin-right:10px;opacity:0.4;"></i>
							</div> -->
							<div class="ggnm" style="margin-top:5px;">
								<img src="../assets/2.png" class="ggnm" />
							</div>
						</div>
						<div class="font nmb" @click="tzc()">
							<!-- <div class="ggnm flex flexjust flexali activec" style="justify-content: space-between;margin-top:5px;">
								<div class="flex" style="flex-direction: column;margin-left:20px;color:white;">
									<div style="font-size:16px;">需求发布</div>
									<div class="colortm">DEMAND RELEASE</div>
								</div>
								<i class="el-icon-caret-right" style="margin-right:10px;opacity:0.4;"></i>
							</div> -->
							<div class="ggnm" style="margin-top:5px;">
								<img src="../assets/3.png" class="ggnm" />
							</div>
						</div>
					<div class="font flex colorwhite" style="flex-direction: column;margin-bottom:10px;">
						<div class="font nmb" v-for="(item,index) in mok" :key="index" @click="tz(index)">
							<!-- <div class="ggnm flex flexjust flexali" style="justify-content: space-between;margin-top:5px;" :style="(index+1)%2==1?'background-color:#425987;':'background-color:#B5B5B5;'">
								<div class="flex" style="flex-direction: column;margin-left:20px;">
									<div style="font-size:16px;">{{item.name}}</div>
									<div class="colortm">LATEST TRAINING</div>
								</div>
								<i class="el-icon-caret-right" style="margin-right:10px;opacity:0.4;"></i>
							</div> -->
							<div class="ggnm" style="margin-top:5px;">
								<img :src="urls+item.url" class="ggnm" />
							</div>
						</div>
					</div>
					<!-- 二维码 -->
					<!-- <div style="display:flex; width:310px;margin-top:20px;">
						<div class="bodyb">
							<img style="width:37px;height: 37px;" :src="urls+weapon.url"></img>
							<div class="font bjtop">创械圈</div>
						</div>
						<div class="bodyb">
							<img style="width:37px;height: 37px;" :src="urls+ideal.url"></img>
							<div class="font bjtop">理实国际</div>
						</div>
						<div class="bodyb">
							<img style="width:37px;height: 37px;" :src="urls+school.url"></img>
							<div class="font bjtop">学院</div>
						</div>
					</div> -->
				</div>
			</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"Home",
		components:{
		},
		data() {
			return {
				totals:null,//总条数 
				datalisid:'',
				tabid:'',
				lengths:'',
				urls:'',
				flid:'1',
				length:'',
				currentpage:1,
				pagesize:22,
				tarhave:'',
				url:'https://www.baidu.com/',
				tabIndex:0,
				tabIndexs:0,
				pid:[],
				dxb:[],
				tp:'',
				mok:'',
				zx:'',
				ks:'',
				tpa:'',
				tpas:'',
				tpb:'',
				tpc:'',
				tpd:'',
				tpds:'',
				tpe:'',
				tpf:'',
				tpfs:'',
				tpg:'',
				titlea:'',
				titleb:'',
				titlec:'',
				ideal:'',//理实国际二维码
				weapon:'',//创械圏二维码
				school:'',//学院二维码
				titlesid:'',//园区详情ID
				bannerthree:'',
				bannerfour:'',
			}
		},
		created() {
			this.hwewr()
			//获取首页一级分类接口
			axios({
			    url: `${base.url}/api/user/homeOne`,
			    method: 'post',
			    data:''
			}).then((res) => {
						this.tarhave=res.data
						this.length=res.data.length
						//map循环添加元素到数组
						res.data.map(item=>{
							this.pid.push(item.id)
						})
						this.halou();
			        })
			//获取首页分类接口
			axios({
			    url: `${base.url}/api/user/homeClass`,
			    method: 'post',
			    data:''
			}).then((res) => {
				this.zx=res.data
			        })
			//获取首页广告图接口
			axios({
			    url: `${base.url}/api/user/activity`,
			    method: 'post',
			    data:''
			}).then((res) => {
				if(res){
					this.tp=res.data
					this.urls=res.url
					if(res.data.length!=0){
						this.tpa=res.data.slice(0,1)
						this.tpas=this.tpa[0]
						}
					if(res.data.length>=1){
						this.tpb=res.data.slice(1,7)
						}
					if(res.data.length>=9){
						this.tpc=res.data.slice(7,10)
						}
					if(res.data.length>=14){
						this.tpe=res.data.slice(10,14)
						}		
					if(res.data.length>15){
						this.tpg=res.data.splice(15)
						}
				}
			        })
			//首页分类轮播图1
			axios({
			    url: `${base.url}/api/user/banner`,
			    method: 'post',
			    data:{type:'3'}
			}).then((res) => {
						if(res){
							this.bannerthree=res.data
						}
			        })	
			//首页分类轮播图2
			axios({
			    url: `${base.url}/api/user/banner`,
			    method: 'post',
			    data:{type:'4'}
			}).then((res) => {
						if(res){
							this.bannerfour=res.data
						}
			        })			
			//获取园区列表接口
			axios({
			    url: `${base.url}/api/user/park`,
			    method: 'post',
			    data:''
			}).then((res) => {
				if(res.code==1){
					this.mok=res.data
					console.log(res);
				}
			        })
			//获取系统信息
			const data={
					field:['blog','college','public','curriculum','books','weapon','ideal','school','character','character_src']
			}
			axios({
			    url: `${base.url}/api/user/getRule`,
			    method: 'post',
			    data:data
			}).then((res) => {
						this.url=res.data
						// console.log(this.url);
						this.ideal =res.data.ideal[0]
						this.school =res.data.school[0]
						this.weapon =res.data.weapon[0]
			        })									
		},
		methods: {
			handleCurrentChange(val){
				this.titlea=''
				this.titleb=''
				this.titlec=''
				this.hwewr(val)
			},
			wztza:function(e){
				this.$store.commit("navbgshow",9)
				this.datalisid=e
				this.$router.push({path:'/Home/details',query:{data:this.datalisid,datas:1}});
			},
			wztzb:function(e){
				this.$store.commit("navbgshow",9)
				this.datalisid=e
				this.$router.push({path:'/Home/details',query:{data:this.datalisid,datas:1}});
			},
			wztzc:function(e){
				this.$store.commit("navbgshow",9)
				this.datalisid=e
				this.$router.push({path:'/Home/details',query:{data:this.datalisid,datas:1}});
			},
			halou:function(){
				//获取首页二级分类接口
				axios({
				    url: `${base.url}/api/user/homeTwo`,
				    method: 'post',
				    data:{pid:this.pid}
				}).then((res) => {
					if(res){
						this.ks=res.data
						this.lengths=res.data.length
					}
				        })
			},
		changes:function(e){
				this.tabIndexs=e
				this.flid=this.zx[e].id
				this.titlea=''
				this.titleb=''
				this.titlec=''
				this.currentpage=1
				this.hwewr()
		},
		hwewr:function(e){
			let page=e
			//获取首页文章
			const datas={
				pid:this.flid,
				page:page
			}
			axios({
			    url: `${base.url}/api/user/honeNews`,
			    method: 'post',
			    data:datas
			}).then((res) => {
				this.dxba=res.data.data
				//总条数
				 this.totals=Number(res.data.total)
				// console.log(res);
				if(res.data.data.length!=0){
					this.titlea=res.data.data.slice(0,6)
					}
				if(res.data.data.length>6){
					this.titleb=res.data.data.slice(6,15)
				}
				 if(res.data.data.length>15){
					this.titlec=res.data.data.slice(15)
				}
				// console.log(this.titlea);
				// console.log(this.titleb);
				// console.log(this.titlec);
			        })
		},
		tza:function(){
			this.$router.push({path:'collgetwo'});
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",1)
		},
		tzb:function(){
			this.$router.push({path:'modify'});
			this.$store.commit("meetingshow",1)
			this.$store.commit("navbgshow",9)
		},
		tzc:function(){
			this.$router.push({name:'detailthree'});
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",0)
		},
		tzd:function(){
			this.$router.push({path:'collegethree'});
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",1)
		},
		tze:function(){
			this.$router.push({path:'collegefour'});
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",1)
		},
		tz:function(e){
			this.titlesid=this.mok[e].id
			this.$router.push({path:'/Home/activity',query:{data:this.titlesid}});
			this.$store.commit("meetingshow",0)
			this.$store.commit("business",0)
			this.$store.commit("navbgshow",9)
			let a=this.$store.state.navbg
		},
		zxhy:function(){
			this.$router.push({path:'meeting'})
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",1)
		},
		tapone:function(e){
			this.tabid=this.ks[e].id
			this.$store.commit("navbgid",this.tabid)
			this.$router.push({name:'cardiovascular',params:{data:this.tabid,type:this.tarhave,types:this.ks}});
		}
		},
	}
</script>

<style lang="scss" scoped>
	.zxfont{
		font-weight:600;
		padding-bottom:5px;
	}
	.zxfont:hover{
	 color:#767676 !important;
	 cursor:pointer;
	 }
	.fontcolors{
		overflow:hidden;
		white-space:nowrap;
		text-overflow:ellipsis;
		color:#767676;
		font-size:14px;
	}
	.fontcolors:hover{
	 color:#20919D;
	 cursor:pointer
	 }
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.bjmagin{
		margin:0px 10px 0px;
	}
	.bjmagins{
		margin:0px 10px 0px 0px;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 29px;
		line-height:29px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.activeb{
		background-color:#B5B5B5 !important;
	}
	.activec{
		background-color:#E27265 !important;
	}
	.mas{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
	}
	.mass{
		width:13px;
		height: 2px;
		background-color: #38A5EC;
		margin-top:5px;
	}
	.masr{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
		margin-left:10px;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		height:56px;
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.kes{
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
		color:#848484;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.font{
		font-size:14px;
	}
	.colortm{
		font-size: 12px;
		opacity:0.2;
		margin-top:5px;
	}
	.fontcolor{
		color:#767676;
	}
	.fontcolor:hover{
	color:#20919D;
	}
	.zt{
		color:#767676;
		font-size:14px;
	}
	.has{
		background-color:#38A5EC;
		width:23px;
		height:2px;
		margin-top:5px;
		margin-left:10px;
	}
	.hass{
		background-color:#38A5EC;
		width:23px;
		height:2px;
		margin-top:5px;
	}
	.hove{
		margin:10px 2% 10px; 
		width:96%;
		background-color:#EEEEEE;
		height:2px;
	}
	.yerw{
		margin-left: 20px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.nmb{
		margin-top: 8px;
	}
	.nmb:hover{
		cursor:pointer;
	}
	.bodyb{
		background-color:#20919D;
		width:103px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.bodyb:hover{
	background-color:#5AD6CE;
	}
	.bodyd{
		background-color:#20919D;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.bodyd:hover{
	background-color:#5AD6CE;
	
	}
	.nvbc{
		background-color:#20919D;
		width: 94px;
		height: 116px;
	}
	.nvbc:hover{
		cursor:pointer;
	}
	.ggnm{
		width:310px;
		height:76px;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
</style>
